import { RestClient as RC } from '@ps-smart-cp/ppfw-client';
import { withSpace } from './spaceRequestContext';

const faRestClient = new RC(process.env.ORIGIN_SERVER_URL);
const authRestClient = new RC(process.env.AUTH_ORIGIN_SERVER_URL, false);

/** FA の GET へ Space コンテキストを付与する。合成規則は {@link withSpace}。 */
function faGet<T>(path: string, params: Record<string, number | string> = {}): Promise<T> {
  return faRestClient.get<T>(path, withSpace(params));
}

/**
 * FA の POST へ Space コンテキストを付与する。
 *
 * `faRestClient` は `wrapInValues=true` のままなので、最終的な wire body は
 * `{ values: { spaceCode?, ...body } }` になる（呼び出し側の明示を優先する）。`spaceCode`
 * 未設定時は key を追加せず、`spaceAsOf` は前端では生成しない。合成規則は {@link withSpace}。
 */
function faPost<T>(path: string, body: object = {}, options?: { largeBody: boolean }): Promise<T> {
  return faRestClient.post<T>(path, withSpace(body), options);
}

/** FA の PUT へ Space コンテキストを付与する。合成規則は {@link faPost} と同じ。 */
function faPut<T>(path: string, body: object, options?: { largeBody: boolean }): Promise<T> {
  return faRestClient.put<T>(path, withSpace(body), options);
}

/** FA の DELETE へ Space コンテキストを付与する。合成規則は {@link faGet} と同じ。 */
function faDelete<T>(path: string, params: Record<string, string> = {}): Promise<T> {
  return faRestClient.remove<T>(path, withSpace(params));
}

const RestClient = {
  fa: {
    get: faGet,
    post: faPost,
    formPost: faRestClient.formPost.bind(faRestClient),
    put: faPut,
    delete: faDelete,
    logError: faRestClient.logError.bind(faRestClient),
  },
  auth: {
    get: authRestClient.get.bind(authRestClient),
    post: authRestClient.post.bind(authRestClient),
    formPost: authRestClient.formPost.bind(authRestClient),
    put: authRestClient.put.bind(authRestClient),
    delete: authRestClient.remove.bind(authRestClient),
    logError: authRestClient.logError.bind(authRestClient),
  },
};

export { RestClient };
